import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const expireCoupaFilesById = async ([payload, controller]) => {
  const response = await axios.post(URLS.DRM_EXPIRE_BY_COUPA_ID, payload, {
    signal: controller.signal,
  });

  if (response.status >= 400) {
    throw new Error(response?.data?.message);
  }

  return response;
};
